import { UserType } from '@lib/firebase';
import { BookingOverview } from '@pages/Booking/Overview';

import { BookingListItem } from '../components/BookingListItem';

export const BookingOverviewCustomer = () => {
  return <BookingOverview BookingItem={BookingListItem} userType={UserType.Customer} />;
};
